import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { LockIcon } from 'components/icons';

export const CantRespondClosedFormAlert = () => {
  return (
    <Alert
      status="warning"
      variant="subtle"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      p={6}
      borderRadius="lg"
    >
      <LockIcon size="4x" />
      <AlertTitle
        mt={6}
        mb={1}
        fontSize="lg"
      >{t`You can't respond to a closed form`}</AlertTitle>
      <AlertDescription maxWidth="sm">
        {t`This form is closed, you can no longer respond to it.`}
      </AlertDescription>
    </Alert>
  );
};
